// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'Titillium Web', 'Titillium Web Fallback'","fontStyle":"normal"},"className":"__className_f5c247"};